import { Crown, Sparkles, Target, Users, Shield, Code } from 'lucide-react'
import { Link } from 'react-router-dom'

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/20 backdrop-blur-md border-b border-white/10">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2">
              <Crown className="w-8 h-8 text-purple-400" />
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                Crown of Suns
              </span>
            </Link>
            <Link to="/">
              <button className="text-gray-400 hover:text-white">← Back to Home</button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="pt-24 pb-12 px-4">
        <div className="container mx-auto max-w-4xl">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <Crown className="w-20 h-20 text-purple-400 mx-auto mb-6" />
            <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              About Crown of Suns
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Crown of Suns is an epic space strategy game where players command vast interstellar empires, 
              engage in diplomatic relations, conduct scientific research, and battle for galactic supremacy.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <Sparkles className="w-12 h-12 text-yellow-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Immersive Gameplay</h3>
              <p className="text-gray-300">
                Experience rich, strategic gameplay with multiple paths to victory and endless possibilities.
              </p>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <Target className="w-12 h-12 text-red-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Strategic Combat</h3>
              <p className="text-gray-300">
                Plan tactical battles, manage fleets, and dominate your enemies through superior strategy.
              </p>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <Users className="w-12 h-12 text-blue-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Multiplayer Universe</h3>
              <p className="text-gray-300">
                Interact with thousands of players in a persistent, ever-evolving galactic civilization.
              </p>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <Shield className="w-12 h-12 text-green-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Alliance System</h3>
              <p className="text-gray-300">
                Form powerful alliances, negotiate treaties, and work together to achieve galactic dominance.
              </p>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <Code className="w-12 h-12 text-purple-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Advanced Technology</h3>
              <p className="text-gray-300">
                Research cutting-edge technologies to unlock new ships, weapons, and galactic capabilities.
              </p>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <Crown className="w-12 h-12 text-gold-400 mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Rise to Power</h3>
              <p className="text-gray-300">
                Build your empire from humble beginnings to become the ultimate ruler of the galaxy.
              </p>
            </div>
          </div>

          {/* Story Section */}
          <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-2xl p-8 border border-purple-500/30 mb-16">
            <h2 className="text-3xl font-bold text-white mb-6 text-center">The Galaxy Awaits</h2>
            <div className="text-gray-300 space-y-4">
              <p>
                In the year 2387, humanity has spread across the stars, establishing colonies on distant worlds 
                and making contact with alien civilizations. The galaxy is divided among powerful factions, 
                each vying for control of precious resources and strategic systems.
              </p>
              <p>
                As a newly appointed commander, you must navigate the complex web of galactic politics, 
                build and command mighty fleets, conduct groundbreaking research, and forge alliances 
                that will determine the fate of entire civilizations.
              </p>
              <p>
                Will you lead through diplomacy and trade, or will you conquer through military might? 
                The choice is yours, and the Crown of Suns awaits the one bold enough to claim it.
              </p>
            </div>
          </div>

          {/* Development Team */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-white mb-6">Development Team</h2>
            <p className="text-gray-300 mb-8">
              Crown of Suns is developed by a passionate team of game developers, space enthusiasts, 
              and strategy game veterans dedicated to creating the ultimate galactic conquest experience.
            </p>
            <div className="flex justify-center">
              <Link to="/register">
                <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-3 px-8 rounded-lg text-lg">
                  Join the Galaxy
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About